"use strict";
import { Core as YubinBangoCore } from "yubinbango-core2";
export function createBirthdayOptionJs() {
  const start = 2000;
  const now = new Date();
  const year = now.getFullYear();

  createOption(start, year, "年", $("#birthYear"));
  createOption(1, 12, "月", $("#birthMonth"));
  createOption(1, 31, "日", $("#birthDate"));

  function createOption(start, end, text, id) {
    let option;
    for (let index = start; index <= end; index++) {
      option += '<option value="' + index + '">' + index + text + "</option>";
    }
    id.append(option);
  }
}

export function fetchAddress() {
  const postalCode = $('input[name="postal-code"]');
  let address1, address2, address3;
  postalCode.on("change", function (e) {
    const target = e.target.value;
    new YubinBangoCore(target, function (addr) {
      // region=都道府県, locality=市区町村, street=町域
      address1 = addr.region;
      address2 = addr.locality;
      address3 = addr.street;
      $(".address1").val(address1);
      $(".address2").val(address2 + address3);
    });
  });
}
